import { $fetch } from 'ohmyfetch'
import useSWR from 'swr'
import type { Fetcher } from 'swr/dist/types'
import { getRpcUrlForChain } from '../../web3/chains'

// alchemy
interface NftMetadata {
  image?: string
  attributes?: Array<Record<string, any>>
  name: string
  revealed: boolean
}
interface TokenUri {
  raw: string
  gateway: string
}
interface NftMedia {
  uri?: TokenUri
}
interface NftContract {
  address: string
}
interface NftId {
  tokenId: string
  tokenMetadata?: NftTokenMetadata
}
interface NftTokenMetadata {
  tokenType: 'ERC721' | 'ERC1155'
}

export interface NftDataWithMetadataFromAlchemy {
  contract: NftContract
  id: NftId
  title: string
  description: string
  tokenUri?: TokenUri
  media?: NftMedia[]
  metadata?: NftMetadata
  timeLastUpdated: string
}

// alchemy getnfts for wallet
export interface NftDataFromAlchemy extends BaseNftDataFromAlchemy {
  title: string
  description: string
  tokenUri?: TokenUri
  media?: NftMedia[]
  metadata?: NftMetadata
  timeLastUpdated: string
  error?: string
}
export interface BaseNftDataFromAlchemy {
  contract: NftContract
  id: NftId
}

// https://docs.alchemy.com/alchemy/enhanced-apis/nft-api/getnfts#returns
export interface GetNftsBalanceFromAlchemyResponse {
  ownedNfts: NftDataFromAlchemy[]
  pageKey?: string
  totalCount: number
  error?: string
  blockHash?: string
}

const fetchNftsOwnedByContractAddress = async (
  walletAddress: string,
  contractAddress: string | string[],
  chainId: string,
) => {
  const rpcUrl = getRpcUrlForChain(chainId)
  if (!rpcUrl) {
    console.warn(`No RPC Url found for chain ${chainId}`)
    return null
  }

  const contractAddressFragment = Array.isArray(contractAddress)
    ? contractAddress.map((address) => `contractAddresses[]=${address}`).join('&')
    : `contractAddresses[]=${contractAddress}`
  const ownedNftsResponse = await $fetch<GetNftsBalanceFromAlchemyResponse>(
    `${rpcUrl}/getNFTs?owner=${walletAddress}&${contractAddressFragment}`,
  )

  return ownedNftsResponse
}

const useNftsInWalletByCollection = (
  walletAddress: string | undefined,
  collectionAddress: string | string[] | undefined,
  chainId: string | undefined,
  swrConfigOverrides?: Fetcher<GetNftsBalanceFromAlchemyResponse> | undefined,
) => {
  const hasDataToLookup = !!walletAddress && !!collectionAddress && !!chainId

  const swrData = useSWR(
    hasDataToLookup ? [walletAddress, collectionAddress, chainId, 'alchemy-nft-balance'] : null,
    fetchNftsOwnedByContractAddress,
    {
      ...swrConfigOverrides,
    },
  )

  return swrData
}

// const usePagesInWallet = (
//   walletAddress: string | undefined,
//   collectionAddress: string | undefined,
//   chainId: string | undefined,
//   swrConfigOverrides?: Fetcher<GetNftsBalanceFromAlchemyResponse> | undefined,
// ) => {
//   const hasDeps = !!collectionAddress && !!chainId
//   const swrData = useSWR(
//     hasDeps ? [walletAddress, collectionAddress, chainId, 'alchemy-nft-pages-balance'] : null,
//     fetchNftsOwnedByContractAddress,
//     {
//       ...swrConfigOverrides,
//     },
//   )

//   return swrData
// }

export { useNftsInWalletByCollection }
